export default {
  paymentStep: {
    id: 'funnel_page_step_payment',
    defaultMessage: 'Payment',
  },
  previousPage: {
    id: 'funnel_page_previous_page',
    defaultMessage: 'Back to previous page',
  },
  stepperClose: {
    id: 'funnel_page_stepper_close',
    defaultMessage: 'Close',
  },
  stepperCompleted: {
    id: 'funnel_page_stepper_completed',
    defaultMessage: 'Completed',
  },
  stepperCurrent: {
    id: 'funnel_page_stepper_current',
    defaultMessage: 'Current',
  },
  billingStep: {
    id: 'funnel_page_step_shipping',
    defaultMessage: 'Shipping',
  },
  confirmationStep: {
    id: 'funnel_page_step_confirmation',
    defaultMessage: 'Confirmation',
  },
  cartStep: {
    id: 'in_store_checkout_funnel_page_step_cart',
    defaultMessage: 'Cart',
  },
}
